module.exports = __webpack_public_path__ + "img/margit-holzapfel.e193b955.jpg";